var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"operateBtn"},[_c('router-link',{attrs:{"to":"/drivingLicense"}},[_c('div',[_vm._v("车证预约")])]),_c('router-link',{attrs:{"to":"/viewOrder"}},[_c('div',[_vm._v("查看预约")])]),_c('a',{on:{"click":_vm.clickImg}},[_vm._v("行车路线")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }